import Logo from "../../assets/logo.png";
import { useState, useEffect } from "react";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    DashboardOutlined,
    FileTextOutlined,
    SettingOutlined,
    BankOutlined,
    BarChartOutlined,
    ShoppingOutlined,
    DollarOutlined,
    ScheduleOutlined,
    FileOutlined,
    CalendarOutlined,
    CommentOutlined,
    RightOutlined
} from "@ant-design/icons";
import { MdPeople, MdOutlineLibraryBooks, MdOutlinePeopleOutline, MdOutlineCategory, MdOutlineViewArray, MdManageSearch } from "react-icons/md";
import { BsFileBarGraph, BsArrowDownUp, BsBarChartSteps, BsCardHeading, BsGraphUp, BsGift, BsFileEarmarkSpreadsheet, BsCalculator } from "react-icons/bs";
import { Button, Tooltip } from "antd";
import MenuItem from "./menuItem";
import SubMenuItem from "./subMenuItem";
import {ADMIN, FINAL_ACCOUNT, PAYROLL_OFFICER, hasPayrollAccess} from "../../helpers/roles";
import { userStore } from "../../store/userStore";
import { TbFileSettings } from 'react-icons/tb';
import { FaSitemap, FaStore, FaWarehouse } from "react-icons/fa";
import { BiPackage } from "react-icons/bi";
import { GrPaypal } from "react-icons/gr";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { BsArrowLeftRight } from "react-icons/bs";
import { BiNotepad } from "react-icons/bi";
import { TiDocumentAdd } from "react-icons/ti";
import { BsBuilding, BsPencilSquare } from "react-icons/bs";
import { FaBookReader } from "react-icons/fa";
import { GoMortarBoard } from "react-icons/go";


export default function Sidebar({ onCollapse }){
    const [collapsed, setCollapsed] = useState(false);
    const user = userStore(state => state.user);

    // Check window size on initial load and resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
                if (onCollapse) onCollapse(true);
            }
        };

        // Set initial state
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Clean up
        return () => window.removeEventListener('resize', handleResize);
    }, [onCollapse]);

    const toggleCollapse = () => {
        const newCollapsedState = !collapsed;
        setCollapsed(newCollapsedState);
        if (onCollapse) onCollapse(newCollapsedState);
    };

    return(
        <>
            <div className={`sidebar-container ${collapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src={Logo} alt="School Logo" className="logo-image"/>
                        {!collapsed && <div className="brand-divider" />}
                    </div>
                    <Tooltip title={collapsed ? "Expand" : "Collapse"} placement="right">
                        <Button
                            type="text"
                            className="collapse-toggle"
                            onClick={toggleCollapse}
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        />
                    </Tooltip>
                </div>
                <nav className="sidebar-nav">
                    <MenuItem
                        icon={<DashboardOutlined />}
                        title="Dashboard"
                        to="/dashboard"
                        collapsed={collapsed}
                    />
                    <MenuItem
                        icon={<MdPeople />}
                        title="Users"
                        to="/dashboard/users"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(ADMIN)}
                    />
                    <MenuItem
                        icon={<BankOutlined />}
                        title="Offices"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(ADMIN)}
                    >
                        <SubMenuItem
                            icon={<FaBookReader />}
                            title="Departments/Faculties"
                            to="/dashboard/department"
                        />
                        <SubMenuItem
                            icon={<BsPencilSquare />}
                            title="Units"
                            to="/dashboard/unit"
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<BarChartOutlined />}
                        title="Budget"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(ADMIN) ||
                                  user?.roles?.includes("BUDGET_OFFICER") ||
                                  user?.roles?.includes("CREATE_BUDGET")}
                    >
                        <SubMenuItem
                            icon={<AiOutlineFundProjectionScreen />}
                            title="Manage Budget"
                            to="/dashboard/budgets"
                        />
                        <SubMenuItem
                            icon={<MdOutlineViewArray />}
                            title="Staff Projection"
                            to="/dashboard/staff-projection"
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<BsFileBarGraph />}
                        title="Final Account"
                        to="/dashboard/final-accounts"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(FINAL_ACCOUNT)}
                    />
                    <MenuItem
                        icon={<FileTextOutlined />}
                        title="Memo"
                        collapsed={collapsed}
                    >
                        <SubMenuItem
                            icon={<TiDocumentAdd />}
                            title="Manage Memo"
                            to="/dashboard/memo/manage/memo"
                        />
                        <SubMenuItem
                            icon={<CommentOutlined />}
                            title="Recommendation"
                            to="/dashboard/memo/recommendation"
                        />
                        {/*<SubMenuItem*/}
                        {/*    icon={<TiDocumentAdd />}*/}
                        {/*    title="Manage Claim"*/}
                        {/*    to="/dashboard/memo/manage/claim"*/}
                        {/*/>*/}
                    </MenuItem>
                    <MenuItem
                        icon={<DollarOutlined />}
                        title="Voucher"
                        collapsed={collapsed}
                    >
                        <SubMenuItem
                            icon={<MdManageSearch />}
                            title="Manage"
                            to="/dashboard/voucher"
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<ScheduleOutlined />}
                        title="Payroll"
                        collapsed={collapsed}
                    >
                        <SubMenuItem
                            icon={<TbFileSettings />}
                            title="Manage Payrolls"
                            to="/dashboard/payroll-config"
                            condition={hasPayrollAccess(user?.roles)}
                        />
                        <SubMenuItem
                            icon={<BsFileEarmarkSpreadsheet />}
                            title="Monthly payroll records"
                            to="/dashboard/payroll"
                        />
                        <SubMenuItem
                            icon={<GrPaypal />}
                            title="Payroll Approval"
                            to="/dashboard/payroll-approval"
                            condition={hasPayrollAccess(user?.roles)}
                        />
                        <SubMenuItem
                            icon={<BsGift />}
                            title="Benefits"
                            to="/dashboard/benefit"
                            condition={hasPayrollAccess(user?.roles)}
                        />
                        <SubMenuItem
                            icon={<BsCalculator />}
                            title="Deductions"
                            to="/dashboard/deduction"
                            condition={hasPayrollAccess(user?.roles)}
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<ShoppingOutlined />}
                        title="Store"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(ADMIN)}
                    >
                        <SubMenuItem
                            icon={<FaStore />}
                            title="Stores"
                            to="/dashboard/store"
                        />
                        <SubMenuItem
                            icon={<FaWarehouse />}
                            title="Store Departments"
                            to="/dashboard/store-department"
                        />
                        <SubMenuItem
                            icon={<MdOutlineCategory />}
                            title="Categories"
                            to="/dashboard/category"
                        />
                        <SubMenuItem
                            icon={<BiPackage />}
                            title="Items"
                            to="/dashboard/item"
                        />
                        <SubMenuItem
                            icon={<BsArrowLeftRight />}
                            title="Transactions"
                            to="/dashboard/store-transactions"
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<SettingOutlined />}
                        title="Configuration"
                        collapsed={collapsed}
                        condition={user?.roles?.includes(ADMIN)}
                    >
                        <SubMenuItem
                            icon={<TbFileSettings />}
                            title="Salary Structure"
                            to="/dashboard/voucher-config"
                        />
                        <SubMenuItem
                            icon={<TbFileSettings />}
                            title="Account Type Category"
                            to="/dashboard/budget-category"
                        />
                        <SubMenuItem
                            icon={<FaSitemap />}
                            title="Account Type"
                            to="/dashboard/subaccount-type"
                        />
                        <SubMenuItem
                            icon={<MdOutlineLibraryBooks />}
                            title="Budget Approval Stages"
                            to="/dashboard/budget-approval"
                        />
                        <SubMenuItem
                            icon={<CalendarOutlined />}
                            title="Financial Year"
                            to="/dashboard/financial-year"
                        />
                        <SubMenuItem
                            icon={<TbFileSettings />}
                            title="Staff Category"
                            to="/dashboard/staff-category"
                        />
                        <SubMenuItem
                            icon={<MdOutlinePeopleOutline />}
                            title="Designations"
                            to="/dashboard/designation"
                        />
                        <SubMenuItem
                            icon={<BsArrowDownUp />}
                            title="Voucher Approval"
                            to="/dashboard/voucher-approval"
                        />
                        <SubMenuItem
                            icon={<DollarOutlined />}
                            title="Taxes"
                            to="/dashboard/tax-config"
                        />
                        <SubMenuItem
                            icon={<BsGraphUp />}
                            title="Level"
                            to="/dashboard/level"
                        />
                        <SubMenuItem
                            icon={<BsBarChartSteps />}
                            title="Step"
                            to="/dashboard/step"
                        />
                    </MenuItem>
                    <MenuItem
                        icon={<FileOutlined />}
                        title="Report"
                        to="/dashboard/report"
                        collapsed={collapsed}
                    />
                </nav>
            </div>
        </>
    )
}
